import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { ENASUSPRO_URL } from "@/data/content";
import { Reveal } from "./Reveal";

// Prominent in-page "kutucuk" that transitions to the parent brand enasuspro.com
export const EnasusproSwitch = () => (
  <section className="relative border-t border-white/10 py-24 md:py-32" data-testid="enasuspro-switch">
    <div className="ec-container">
      <Reveal>
        <a
          href={ENASUSPRO_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="enasuspro-switch-link"
          className="group relative block overflow-hidden rounded-3xl border border-white/10 bg-[#101010] p-8 transition-colors duration-300 hover:border-[#D4F870]/50 md:p-14"
        >
          <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#064E3B]/40 blur-[120px] transition-opacity duration-500 group-hover:opacity-80" />
          <div className="relative flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
            <div className="max-w-2xl">
              <p className="ec-eyebrow mb-4">
                <span className="h-1.5 w-1.5 rounded-full bg-[#D4F870]" />
                ANA MARKA — DANIŞMANLIK
              </p>
              <h2 className="font-display text-3xl leading-[1.05] tracking-tight text-[#F3F4F6] sm:text-4xl md:text-5xl">
                Yazılımın ötesinde uzman desteğe mi ihtiyacın var?
              </h2>
              <p className="mt-4 max-w-xl text-sm leading-relaxed text-[#9CA3AF] md:text-base">
                ESG danışmanlığı, sürdürülebilirlik raporlaması ve iklim riski (IFC, EBRD, AIIB, ADB ESDD)
                için ana markamız Enasuspro'ya geçiş yap.
              </p>
            </div>

            <motion.div
              whileHover={{ scale: 1.04 }}
              className="flex shrink-0 items-center gap-4 rounded-2xl border border-white/10 bg-[#0A0A0A] px-6 py-5"
            >
              <div>
                <div className="text-[10px] uppercase tracking-[0.24em] text-[#9CA3AF]">geç</div>
                <div className="font-display text-2xl text-[#F3F4F6]">enasuspro.com</div>
              </div>
              <span className="grid h-12 w-12 place-items-center rounded-full bg-[#D4F870] text-[#0A0A0A] transition-transform duration-300 group-hover:rotate-45">
                <ArrowUpRight className="h-5 w-5" />
              </span>
            </motion.div>
          </div>
        </a>
      </Reveal>
    </div>
  </section>
);
